import type {
  ApiResponse,
  ChangePasswordRequest,
  LoginRequest,
  LoginResponse,
  SetupPinRequest,
  VerifyPinRequest
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class AuthService {
  async login(credentials: LoginRequest): Promise<ApiResponse<LoginResponse>> {
    const response = await apiManager.post<LoginResponse>('/api/v1/admin/login', credentials);

    if (response.status === 'success' && response.data?.token) {
      apiManager.setToken(response.data.token);
    }

    return response;
  }

  async changePassword(data: ChangePasswordRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/change-password', data);
  }

  async setupPin(data: SetupPinRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/setup-pin', data);
  }

  async verifyPin(data: VerifyPinRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/verify-pin', data);
  }

  async getMe(): Promise<ApiResponse<LoginResponse>> {
    return apiManager.get<LoginResponse>('/api/v1/admin/me');
  }

  logout() {
    apiManager.clearToken();
  }
}

export const authService = new AuthService();